module.exports = new __parcel__URL__("GT_P_3_002.2e751711.json").toString();